// Reporta al servidor los errores de la web (Administración → Errores). Solo el tipo, el
// mensaje, la pila y la ruta de la pantalla: nunca datos de formularios ni parámetros.
import { ApiError } from './api';

const MAX_PER_PAGE = 10;
let sent = 0;
const seen = new Set<string>();

/** Archivo de una versión anterior que ya no existe (después de publicar una versión nueva). */
export function isStaleChunkError(e: unknown): boolean {
  const m = e instanceof Error ? e.message : String(e);
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Expected a JavaScript.*MIME type/i.test(m);
}

export function reportError(err: unknown, extra: { componentStack?: string | null } = {}) {
  if (sent >= MAX_PER_PAGE) return;
  const e = err instanceof Error ? err : new Error(typeof err === 'string' ? err : JSON.stringify(err ?? 'Error desconocido'));
  // No son errores de la plataforma: respuestas del servidor (ya registradas allá), cancelaciones,
  // avisos del navegador, extensiones y archivos de una versión anterior.
  if (e instanceof ApiError || e.name === 'AbortError' || isStaleChunkError(e)) return;
  if (/ResizeObserver loop|^Script error\.?$/.test(e.message)) return;
  if (e.stack && /(chrome|moz|safari(-web)?)-extension:/.test(e.stack)) return;
  const key = `${e.name}|${e.message}`;
  if (seen.has(key)) return;
  seen.add(key);
  sent++;
  void fetch('/api/client-errors', {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json', 'X-CSRF': '1' },
    body: JSON.stringify({
      name: e.name.slice(0, 100), message: (e.message || '(sin mensaje)').slice(0, 1000), stack: e.stack?.slice(0, 8000),
      componentStack: extra.componentStack?.slice(0, 4000), path: window.location.pathname.slice(0, 300),
    }),
  }).catch(() => undefined);
}

export function installErrorReporting() {
  window.addEventListener('error', (ev) => reportError(ev.error ?? ev.message));
  window.addEventListener('unhandledrejection', (ev) => reportError(ev.reason));
}
